<script>
  export let numStr
  import { selectedLanguage } from "../etc/store.js"
  import {
    number2code,
    findGua,
    checkChanging,
    getMovingYaoPositions,
    checkChangingMatch,
    checkMoving,
    generateZhi1,
    zongGua,
    cuoGua,
    jiaoGua,
    huGua,
    gig14,
    gig15,
    gig26,
    gig36,
  } from "../etc/helpers.js"

  //  console.log("@ GuaResult - numStr is " + numStr)
</script>

<!-- <div class="show-gua">The number string is {numStr}</div> -->
<div class="gua-result">
  <!-- <h4>起卦結果</h4> -->
  {#if $selectedLanguage == "TW"}
    <div id="ben-gua">
      本卦：
      {numStr.length != 6
        ? ""
        : findGua(number2code(numStr), $selectedLanguage)}
      <br />
      宜變之爻：{checkChanging(numStr)}
      <br />
      動爻：{getMovingYaoPositions(numStr) == "unmoved"
        ? "無動爻"
        : getMovingYaoPositions(numStr)}
      /
      {checkChangingMatch(numStr) == "unchanged"
        ? "無宜變"
        : checkChangingMatch(numStr)}
    </div>
    <div id="zhi1">第一之卦：{generateZhi1(numStr)}</div>
    <div id="zhi2">
      第二之卦：{findGua(checkMoving(numStr), $selectedLanguage)}
    </div>
    <div id="zong-gua">
      綜卦：{findGua(zongGua(number2code(numStr)), $selectedLanguage)}
    </div>
    <div id="cuo-gua">
      錯卦：{findGua(cuoGua(number2code(numStr)), $selectedLanguage)}
    </div>
    <div id="jiao-gua">
      交卦：{findGua(jiaoGua(number2code(numStr)), $selectedLanguage)}
    </div>
    <div id="gig2-5">
      互卦（卦中卦（2-5））：{findGua(
        huGua(number2code(numStr)),
        $selectedLanguage
      )}
    </div>
    <div id="gig1-4">
      卦中卦（1-4）： {findGua(gig14(number2code(numStr)), $selectedLanguage)}
    </div>
    <div id="gig1-5">
      卦中卦（1-5）：{findGua(gig15(number2code(numStr)), $selectedLanguage)}
    </div>
    <div id="gig2-6">
      卦中卦（2-6）：{findGua(gig26(number2code(numStr)), $selectedLanguage)}
    </div>
    <div id="gig3-6">
      卦中卦（3-6）：{findGua(gig36(number2code(numStr)), $selectedLanguage)}
    </div>
  {:else}
    <div id="ben-gua">
      本卦：
      {numStr.length != 6
        ? ""
        : findGua(number2code(numStr), $selectedLanguage)}
      <br />
      宜变之爻：{checkChanging(numStr)}
      <br />
      动爻：{getMovingYaoPositions(numStr) == "unmoved"
        ? "无动爻"
        : getMovingYaoPositions(numStr)}
      /
      {checkChangingMatch(numStr) == "unchanged"
        ? "无宜变"
        : checkChangingMatch(numStr)}
    </div>
    <div id="zhi1">第一之卦：{generateZhi1(numStr)}</div>
    <div id="zhi2">
      第二之卦：{findGua(checkMoving(numStr), $selectedLanguage)}
    </div>
    <div id="zong-gua">
      综卦：{findGua(zongGua(number2code(numStr)), $selectedLanguage)}
    </div>
    <div id="cuo-gua">
      错卦：{findGua(cuoGua(number2code(numStr)), $selectedLanguage)}
    </div>
    <div id="jiao-gua">
      交卦：{findGua(jiaoGua(number2code(numStr)), $selectedLanguage)}
    </div>
    <div id="gig2-5">
      互卦（卦中卦（2-5））：{findGua(
        huGua(number2code(numStr)),
        $selectedLanguage
      )}
    </div>
    <div id="gig1-4">
      卦中卦（1-4）： {findGua(gig14(number2code(numStr)), $selectedLanguage)}
    </div>
    <div id="gig1-5">
      卦中卦（1-5）：{findGua(gig15(number2code(numStr)), $selectedLanguage)}
    </div>
    <div id="gig2-6">
      卦中卦（2-6）：{findGua(gig26(number2code(numStr)), $selectedLanguage)}
    </div>
    <div id="gig3-6">
      卦中卦（3-6）：{findGua(gig36(number2code(numStr)), $selectedLanguage)}
    </div>
  {/if}
</div>
